/* Eldora · Gold Rush interactions: scroll reveal, one-tap add-to-bag, Mix & Match "add both",
   sticky add-to-cart fallback. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.gr-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  // The theme's sticky add-to-cart bar relies on an IntersectionObserver that does not always
  // fire on mobile; mirror its rule from scroll position: show once the main buy buttons are
  // scrolled past, hide again near the footer.
  function initStickyFallback() {
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    var block = document.querySelector('.product-information .buy-buttons-block');
    if (!bar || !block) return;
    var footer = document.querySelector('footer');
    var last = 0;
    function update() {
      last = Date.now();
      var passed = block.getBoundingClientRect().bottom < 0;
      var nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight + 200;
      var want = passed && !nearFooter ? 'true' : 'false';
      if (bar.dataset.stuck !== want) bar.dataset.stuck = want;
    }
    window.addEventListener('scroll', function () {
      if (Date.now() - last > 120) update();
      clearTimeout(bar._grStickyTimer);
      bar._grStickyTimer = setTimeout(update, 140);
    }, { passive: true });
    update();
  }

  function burst(button) {
    if (reduceMotion) return;
    var wrap = document.createElement('span');
    wrap.className = 'gr-burst';
    wrap.setAttribute('aria-hidden', 'true');
    [[-70, -40], [-34, -62], [0, -72], [36, -60], [72, -38], [-92, -8], [94, -6]].forEach(function (p, i) {
      var dot = document.createElement('i');
      dot.style.setProperty('--x', p[0] + 'px');
      dot.style.setProperty('--y', p[1] + 'px');
      dot.style.animationDelay = i * 14 + 'ms';
      wrap.appendChild(dot);
    });
    button.appendChild(wrap);
    setTimeout(function () { wrap.remove(); }, 950);
  }

  function markAdded(button) {
    button.dataset.state = 'added';
    burst(button);
    clearTimeout(button._grTimer);
    button._grTimer = setTimeout(function () { button.dataset.state = ''; }, 1800);
  }

  function announceCart(sourceId, sections) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var update = new Event('cart:update', { bubbles: true });
        update.detail = { resource: cart, sourceId: sourceId, data: { source: 'gold-rush', itemCount: cart.item_count, sections: sections || undefined } };
        document.dispatchEvent(update);
      });
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    // The homepage cart popup may take a card click first (it calls preventDefault):
    // then only play the feedback here, never add twice.
    var cardButton = event.target.closest('form[data-gr-form] [name="add"]');
    if (cardButton && event.defaultPrevented) markAdded(cardButton);

    // Mix & Match pair: add both perfumes exactly like the Mix & Match page does,
    // so the bundle discount applies at checkout.
    var pairButton = event.target.closest('[data-gr-pair]');
    if (!pairButton || pairButton.dataset.state === 'loading') return;
    event.preventDefault();
    var d = pairButton.dataset;
    var bundleId = 'mm_' + Date.now() + '_' + Math.random().toString(36).substring(2, 8);
    var items = ['a', 'b'].map(function (k) {
      return {
        id: parseInt(d[k + 'Variant'], 10),
        quantity: 1,
        properties: {
          _bundle: 'mixmatch',
          _bundle_id: bundleId,
          _min_price: d[k + 'Min'] || '0',
          _product_title: d[k + 'Title'] || '',
          _product_image: d[k + 'Image'] || '',
          _product_url: d[k + 'Url'] || ''
        }
      };
    });
    var payload = { items: items };
    var ids = cartSectionIds();
    if (ids.length) payload.sections = ids.join(',');
    pairButton.dataset.state = 'loading';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('pair add failed');
        return res.json();
      })
      .then(function (response) {
        markAdded(pairButton);
        return announceCart('gold-rush-pair', response.sections);
      })
      .catch(function () {
        pairButton.dataset.state = '';
        window.location.href = d.fallback || '/pages/mix-match';
      });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-gr-form')) return;
    var button = form.querySelector('[name="add"]');
    if (event.defaultPrevented) {
      if (button) markAdded(button);
      return;
    }
    event.preventDefault();
    if (button) button.dataset.state = 'loading';

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        if (button) markAdded(button);
        return announceCart(form.id || 'gold-rush');
      })
      .catch(function () {
        if (button) button.dataset.state = '';
        form.submit();
      });
  });

  document.addEventListener('shopify:section:load', function (event) { initReveal(event.target); });

  document.documentElement.classList.add('gr-ready');
  initReveal();
  initStickyFallback();
})();